/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Cognos Analytics Home
 *| (C) Copyright IBM Corp. 2020, 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define({
	homePageTitleLabel: 'Domovská stránka',
	myContent: 'Můj obsah',
	teamContent: 'Obsah Tým',
	folder: 'Složka',
	files: 'Soubory',
	actionMenu: 'Nabídka akcí',
	myFolder: 'Moje složky',

	emptyFolderNoContent: 'Bez obsahu',

	//EmptyStates
	emptyRecentTitle: 'V poslední době jste nezobrazili žádný obsah.',
	emptyStateTitle: 'Začněte přidáním dat',
	emptyStateBody: 'Klepněte výše na volbu Odeslat data, nebo data odešlete přetažením.',
	emptySearchResultTitle: 'Hledání nevrátilo žádné výsledky.',
	emptyPortalTitle: 'Žádné portály',
	emptyPortalBody: 'Nyní nemáte žádné portály.',
	emptyWsProjectTitle: 'Začněte vytvořením zápisníku v produktu Watson Studio.',
	emptyWsProjectBody: 'Když se vrátíte do produktu Cognos Analytics, váš zápisník se zde objeví.',
	emptyFilteredResultTitle: 'Použité filtry nevrátily žádné výsledky.',
	emptyDialogViewTitle: 'Žádné položky',
	removeFromRecents: 'Odebrat z nedávných',

	// Welcome Banner
	welcomeBannerGreeting: 'Dobrý den. Vítá vás produkt Cognos Analytics.',
	welcomeBannerDescription: 'Produkt Cognos Analytics dává uživatelům nástroje pro samoobslužnou analýzu s podporou umělé inteligence. Podívejte se, jak automatizovaná příprava dat, zjišťování dat a vizualizace můžou vést k přesvědčivějším rozhodnutím.',
	welcomeBannerDescription_trialUser: 'Můžete rovnou začít, když se podíváte na naše úvodní video, prohlídku produktu a kartu Začínáme.',
	takeTourButtonLabel: 'Absolvovat prohlídku produktu',
	watchVideoButtonLabel: 'Sledovat video',
	// confirmation dialog
	hideWelcomeBannerMsg: 'Opravdu chcete vypnout uvítací pruh na domovské stránce? Můžete ho kdykoli znovu zapnout pomocí voleb Profil a nastavení > Nastavení > Obecné. ',
	hideWelcomeBannerTitle: 'Vypnout uvítací pruh',
	ok: 'OK',
	cancel: 'Storno',
	//howto video dialog
	modal_how_title: 'Videa s postupy',
	modal_overview_title: 'Sledovat přehled produktu Cognos Analytics',
	modal_how_play: 'Přehrát video',
	modal_how_video_title_overview: 'Přehled',
	modal_how_video_title_getStarted: 'Začínáme s verzí 11.2',
	modal_how_video_title_newUI: 'Vítejte v novém prostředí Cognos',
	modal_how_video_title_dataModule: 'Přehled datových modulů',
	modal_how_video_title_explore: 'Přehled prozkoumání dat',
	modal_how_video_title_dashboard: 'Přehled interaktivních panelů dashboard',
	modal_how_video_title_reporting: 'Přehled vytváření sestav',
	modal_how_video_title_mobile: 'Síla produktu Cognos ve vašich rukách',

	// Toolbar
	search: 'Hledat',
	addFolder: 'Přidat složku',
	addLink: 'Přidat odkaz',
	filter: 'Filtr',
	sort: 'Řadit',
	settings: 'Nastavení',
	tilesView: 'Zobrazení dlaždic',
	listView: 'Zobrazení seznamu',
	columnView: 'Zobrazení sloupců',

	// Toolbar Actions
	sortBy: 'Seřadit podle',
	sortOrder: 'Seřadit',
	name: 'Název',
	modifiedTime: 'Změněno',
	type: 'Typ',
	ascending: 'Vzestupně',
	descending: 'Sestupně',

	filterType: 'Typ',
	filterModificationTime: 'Změněno',
	all: 'Vše',
	today: 'Dnes',
	yesterday: 'Včera',
	pastWeek: 'Minulý týden',
	pastMonth: 'Minulý měsíc',
	resetFilters: 'Resetovat filtry',

	filterSearchPlaceHolder: 'Filtrovat podle klíčových slov',

	resetFilterTag: 'Klepnutím na X resetujete filtry.',
	filterTagToolTip: 'Použité filtry: %{appliedFilters}.',

	folderName: 'Název složky',
	addAFolder: 'Přidat složku',
	add: 'Přidat',
	error: 'Chyba',
	newFolderDefaultName: 'Nová složka',
	toastCreateNewFolder: 'Složka %{nameOfFolder} byla vytvořena v %{tabName}.',
	folderAdded: 'Přidána složka',
	refresh: 'Obnovit',
	openFolder: 'Otevřít složku',

	addAUrl: 'Přidat adresu URL',
	linkName: 'Název adresy URL',
	linkNamePlaceholder: 'Přidat název adresy URL',
	linkDescription: 'Popis (volitelný)',
	linkDescriptionPlaceholder: 'Přidat popis',
	linkUri: 'Adresa URL',
	linkUriPlaceholder: 'Přidat adresu URL s přijatelnou doménou',
	acceptableDomains: 'Přijatelné domény',
	viewAcceptableDomains: 'Zobrazit přijatelné domény',
	mandatoryField: 'Povinné pole',
	linkAdded: 'Přidána adresa URL',
	toastCreateNewLink: 'Odkaz %{nameOfLink} byl přidán do %{tabName}.',
	noEntries: 'V seznamu přijatelných domén nejsou žádné položky. Obraťte se na administrátora.',

	compact: 'Kompaktní',
	short: 'Krátký',
	default: 'Výchozí',
	rowSize: 'Velikost řádku',

	// GroupyByTypes
	folders: 'Složky',
	reports: 'Sestavy',
	dashboards: 'Panely dashboard',
	data: 'Data',
	packages: 'Balíky',
	explorations: 'Prozkoumání',
	stories: 'Scénáře',
	notebooks: 'Zápisníky',
	others: 'Ostatní',

	// Error Messages
	itemsOverLimit: 'Zadaný název "%{itemName}" překročil maximální povolenou délku (20). Chcete-li pokračovat, zadejte jiný název.',
	errorMessageLengthFolderName: 'Zadejte název složky. Délka názvu nesmí překročit 255 znaků.',
	errorMessageLengthLinkName: 'Zadejte název odkazu. Délka názvu nesmí překročit 255 znaků.',
	toastLaunchPerspectiveError: 'Objekt %{objectType} nelze otevřít.',
	errorNoAccessTitle: 'Zdá se, že k tomuto obsahu nemáte přístup.',
	errorNoAccessBody: 'Kontaktujte administrátora nebo pomocí tohoto odkazu vyhledejte další informace:',
	errorEnableExternalContent: 'Povolení externího obsahu',

	//TableHeader
	lastModified: 'Poslední úpravy',
	location: 'Umístění',
	tenant: 'Tenant',

	// GetStartedTab
	getStartedLabel: 'Začínáme s produktem IBM Cognos Analytics',
	learningHowToLabel: 'Vzdělávací prostředky',
	learningHowToDescription: 'Rozšiřte své znalosti a získejte pomoc připojením ke komunitě, čtením dokumentace a sledováním videí.',
	learningHowToActionLabel: 'Spustit podokno vzdělávání',
	howToVideosLabel: 'Videa s postupy',
	howToVideosDescription: 'Naučte se, jak používat produkt IBM Cognos Analytics a získávat náhledy na svá data.',
	howToVideosActionLabel: 'Sledovat videa',
	acceleratorCatalogLabel: 'Katalog akcelerátorů',
	acceleratorCatalogDescription: 'Procházejte rostoucí katalog oborového použití, návody s osvědčenými postupy, vlastní vizualizace a další.',
	acceleratorCatalogActionLabel: 'Procházet katalog',
	sampleSectionTitle: 'Ukázky',
	sampleSectionDescription: 'Experimentujte s příklady, které ukazují všechny možnosti nabízené produktem Cognos Analytics.',
	// Samples Section
	createDashboardSampleTitle: 'Postup vytvoření prvního panelu dashboard',
	createDashboardSampleDescription: 'Zahajte svou analytickou kariéru pomocí panelů dashboard produktu Cognos.',
	covid19SampleTitle: 'Panel dashboard COVID',
	covid19SampleDescription: 'Prozkoumejte umění možného pomocí tohoto panelu dashboard produktu Cognos, který analyzuje data související s nemocí COVID-19, a vlastních  rozšíření.',
	sankeySampleTitle: 'Sankeyův',
	sankeySampleDescription: 'Rozšiřte svou knihovnu vizualizací o vlastní vizualizace, jako je Sankeyův diagram.',
	viewAllSamplesActionLabel: 'Zobrazit všechny ukázky',
	byFeatureTitle: 'Podle funkce',
	byFeatureDescription: 'Procházejte ukázky podle funkce, jako jsou funkce jádra, vlastní ovládací prvky, rozšíření, zápisníky a relativní data.',
	byIndustryTitle: 'Podle oboru',
	byIndustryDescription: 'Procházejte ukázky podle oboru, jako je autopříslušenství, bankovnictví a další.',
	// SamplesTab
	sampleTabTitle: 'Získejte inspiraci z našich předem připravených ukázek',
	sampleTabLabel: 'V katalogu akcelerátorů najdete další ukázky a rozšíření od společnosti IBM, partnerů a zákazníků',

	// quickLaunch
	quickLaunchLabel: 'Rychlé spuštění',
	expand: 'Rozbalit',
	collapse: 'Sbalit',

	// quickLaunch dialog
	quickLaunchModalLabel: 'Začněte výběrem toho, co chcete vytvořit.',

	// contentPageView
	contentPageTitleLabel: 'Obsah',
	uploadFile: 'Odeslat data',
	new: 'Nový',
	create: 'Vytvořit',
	more: 'Další',

	// open dialog
	selectDataSourcesToAdd: 'Vyberte přidávaný zdroj nebo zdroje dat.',
	openDialogDefaultTitle: 'Otevřít',

	// save dialog
	save: 'Uložit',
	saveAs: 'Uložit jako',
	saving: 'Ukládání...',
	selectedDestination: 'Vybraný cíl: %{nameOfFolder}',
	toastDuplicateFileDifferentType: '\'%{nameOfItem}\' již existuje s jiným typem. Zadejte jiný název.',
	confirmOverwriteTitle: 'Potvrdit nahrazení existujících dat',
	confirmOverwriteMsg: 'Soubor \'%{nameOfFile}\' již existuje. Chcete nahradit jeho data daty obsaženými ve vybraném souboru?',

	// copy move dialog
	copy: 'Kopírovat',
	move: 'Přesunout',
	copyOrMove: 'Kopírovat nebo přesunout: ',
	copyOnly: 'Kopírovat ',
	createShortcut: 'Vytvořit zástupce',
	createShortcutDialogTitle: 'Vytvořit zástupce: ',

	// External asset types
	wsProject: 'Projekt produktu Watson Studio',
	externalContentTypeWs: 'Watson Studio',

	// Asset Types
	package: 'Balík',
	dataModule: 'Datový modul',
	exploration: 'Prozkoumání',
	mode: 'Režim',
	live: 'Živá',
	snapshot: 'Snímek',
	noSnapshotsFound: 'Nebyl nalezen žádný snímek.',
	uploadedFile: 'Odeslaný soubor',
	fileUpload: 'Odeslat data',
	dataSetEx: 'Datová sada',
	externalRepository: 'Externí úložiště',
	queryMode: 'Režim dotazů',
	queryModeCompatible: 'Kompatibilní',
	queryModeDynamic: 'Dynamický',
	report: 'Sestava',
	activeReport: 'Aktivní sestava',
	query: 'Dotaz',
	analysis: 'Analýza',
	dashboard: 'Panel dashboard',
	dashboardTemplate: 'Šablona panelu dashboard',
	jupyterNotebook: 'Zápisník',
	wsNotebook: 'Zápisník produktu Watson Studio',
	jupyter: 'Jupyter',
	ws: 'Watson Studio',
	story: 'Scénář',
	workspace: 'Pracovní prostor',
	pagelet: 'Stránka',
	content: 'Obsah',
	directory: 'Prostor jmen',
	dataSet: 'Datová sada',
	powerPlayCube: 'Krychle PowerPlay',
	powerPlayReport: 'Sestava aplikace PowerPlay',
	powerPlay8Report: 'Sestava aplikace PowerPlay',
	powerPlay8ReportView: 'Zobrazení sestavy PowerPlay',
	reportTemplate: 'Šablona sestavy',
	packageConfigurations: 'Konfigurace balíku',
	agent: 'Agent',
	agentDefinition: 'Definice agenta',
	agentDefinitionView: 'Zobrazení agenta',
	dataMovementTask: 'Úloha přesunu dat',
	dataMovementTaskAlias: 'Alias úlohy přesunu dat',
	document: 'Dokument',
	DocumentRetention: 'Vlastnosti dokumentu',
	jobDefinition: 'Definice úlohy',
	job: 'Úkol',
	metricsDataSourceETLTask: 'Úloha nástroje ETL zdroje dat metrik',
	metricsExportTask: 'Úloha exportu metrik',
	metricsFileImportTask: 'Úloha importu souboru metrik',
	metricsMaintenanceTask: 'Úloha udržování metrik',
	planningTask: 'Úloha plánování',
	shortcut: 'Zástupce',
	URL: 'Adresa URL',
	launchable: 'Spustitelný',
	dataSetFolder: 'Složka datové sady',
	ViewAccessibleLabel: 'Zobrazit %{label}',
	overrideReportOptions: 'Potlačit výchozí volby sestavy',
	formats: 'Formáty',
	saveReport: 'Uložit sestavu',
	promptForValues: 'Zobrazit výzvu',
	reportView: 'Zobrazení sestavy',
	html: 'html',
	pdf: 'pdf',
	spreadsheetML: 'Excel',
	xlsxData: 'Data aplikace Excel',
	csv: 'csv',
	xml: 'xml',
	txt: 'txt',
	//Details
	details: 'Podrobnosti',
	open: 'Otevřít',
	created: 'Vytvořeno',
	modified: 'Změněno',
	owner: 'Vlastník',
	dataSource: 'Zdroj dat',
	share: 'Sdílet',
	addToFavorites: 'Přidat k oblíbeným',
	properties: 'Vlastnosti',
	detailsEmptyStateBody: 'Vyberte položku, abyste zobrazili její podrobnosti',
	editNameAndDescription: 'Upravit název a popis',
	none: 'Žádný',

	//rename dialog
	nameInvalid: 'Název je neplatný',
	namePlaceholder: 'Zadejte název',
	description: 'Popis',
	descriptionInvalid: 'Popis nesmí překročit 350 znaků.',
	descriptionPlaceholder: 'Zadejte popis',
	errorMessageApostropheError: 'Zadejte název souboru, který neobsahuje znaky \' ani ".',
	renameCollisionError: '%{name} již existuje. Zkuste použít jiný název.',
	unknownRenameError: 'Přejmenování položky se nezdařilo. Obraťte se o další pomoc na administrátora.',

	//types
	xls: 'xls',
	xlsx: 'xlsx',

	unableToOpenFolderMsg: 'Určenou složku nelze otevřít.',

	//Upload
	uploadToFolder: "Odeslat do <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>%{launchAction}",
	uploadAndLaunch: "Odeslat do <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> a spustit %{launchAction}",
	quickUpload: "Rychlé odeslání",
	quickUploadAndLaunch: "Přetažením soubory odešlete do <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> a otevřete v jednom z následujících prostorů.",
	unsupportedFilesSingle: "Soubor %{files} nebyl odeslán, protože je neplatný pro Rychlé spuštění.",
	unsupportedFilesMultiple: "Soubory nebyly odeslány, protože všechny vybrané soubory musí být platné pro použití Rychlého spuštění.",
	unsupportedFilesSingleInvalid: "Soubor %{files} je neplatný.",
	unsupportedFilesMultipleInvalid: "Soubory %{files} jsou neplatné.",
	supportedFileTypes: "Povoleny jsou pouze následující typy souborů: %{extensions}.",
	uploadDragAndDrop: "Přetáhnout",
	uploadDragAndDropMessage: "Přetáhněte soubor sem, abyste ho odeslali do <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>",

	// searchBar
	searchWasSaved: 'Vyhledávací kritéria \'%{searchTerm}\' byla uložena.',
	searchWasntSaved: 'Vyhledávací kritéria \'%{searchTerm}\' nebyla uložena.',
	searchSuggestions: 'Návrhy',
	savedSearch: 'Uložená hledání',
	searchWasDeleted: 'Vyhledávací kritéria \'%{searchTerm}\' byla odstraněna.',
	searchWasntDeleted: 'Vyhledávací kritéria \'%{searchTerm}\' nebyla odstraněna.',
	savedBarTitle: 'Hledání produktu Cognos Analytics',
	searchContentPageTitle: 'Hledat',
	searchContentPageTitleLabel: 'Zobrazení výsledků pro \'%{searchTerm}\'',
	showingSearchRsult: 'Zobrazení %{resultCount} položek',
	saveSearch: 'Uložit hledání',
	saveTenSearches: 'Můžete uložit 10 hledání.',
	deleteASearch: 'Odstraňte některou položku, abyste mohli uložit jinou.',
	close: 'Zavřít',

	//recent view
	recents: 'Nedávné',
	noAccessRecent: 'Bez přístupu',
	noAccessRecentMsg: 'K tomuto aktivu nemáte přístup. Je možné, že byl zakázán či odstraněn nebo že vaše oprávnění byla omezena. Ověřte stav aktiva v očekávaném zdrojovém umístění. Klepnutím na tlačítko OK můžete aktivum odebrat z nedávno použitých položek.',
	noAccessMsg: 'K tomuto aktivu nemáte přístup. Je možné, že byl zakázán či odstraněn nebo že vaše oprávnění byla omezena.',

	//contextToolbar
	itemsSelected: 'Počet vybraných položek: %{nameOfSelection}',
	itemSelected: 'Počet vybraných položek: %{nameOfSelection}'

});